import classNames from 'classnames';
import { Fragment, useEffect, useRef, useState } from 'react';
import AnimateIn from './AnimateIn';
import StoryblokEditableComment from './storyblok/StoryblokEditableComment';

const ColumnLists = ({ component }) => {
  let columns = [];

  if (component._uid) {
    component.columns.tbody.forEach((row, index) => {
      columns.push({
        title: row.body[0].value,
        items: row.body[1].value.split(', '),
      });
    });
  } else {
    columns = component.columns;
  }

  return (
    <>
      <AnimateIn className={classNames('column-lists', 'g-row')}>
        <h2>{component.title}</h2>
        <div className="column-lists__cols">
          {columns.map((column) => (
            <div key={column.title} className="column-lists__col">
              <h5 className="column-lists__title"> {column.title} </h5>
              <ul className="u-no-list">
                {column.items.map((item) => (
                  <>
                    <li key={item} className="column-lists__item">
                      {item}
                    </li>
                  </>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </AnimateIn>
    </>
  );
};

export default ColumnLists;
